import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {fetchTranscriptMessages, fetchAttendees} from "../../services/callScore";

import CallScoreFactors from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScoreFactors'
import CallScore from '../CallScore/HumanCallScoreReport/CallWrapUI/CallScore'
import Transcription from '../Transcription/Transcription'
import { formatTranscriptMessages } from "../../utils"
import { SAMPLE_CALL_SCORE, SAMPLE_CONVERSATION_ID } from '../../constants';

const MEETING_DETAILS_MENU = {
    CALLSCORE: 'callscore_menu',
    TRANSCRIPT: 'transcript_menu'
}

const MENU_ITEMS = [
    {
        key: MEETING_DETAILS_MENU.CALLSCORE,
        name: 'Call Score'
    },
    {
        key: MEETING_DETAILS_MENU.TRANSCRIPT,
        name: 'Transcription'
    }
]

const ViewCallScore = () => {
    const location = useLocation();
    let { conversationId, callScore } = location.state || {};

    if (!callScore) {
        conversationId = SAMPLE_CONVERSATION_ID;
        callScore = SAMPLE_CALL_SCORE;
    }

    const [selectedMenu, setSelectedMenu] = useState(MEETING_DETAILS_MENU.CALLSCORE);
    const [transcriptMessages, setTranscriptMessages] = useState([]);
    const [attendeesIdsWithIndex, setAttendeesIdsWithIndex] = useState(null);
    
    // const handleMenuClick = (menu) => {
    //     setSelectedMenu(menu);
    // }

    useEffect(() => {
        if (conversationId) {
          const fetchData = async () => {
            try {
              const [transcriptResponse, attendeeResponse] = await Promise.all([
                fetchTranscriptMessages(conversationId),
                fetchAttendees(conversationId)
              ]);
      
              const formattedMessages = formatTranscriptMessages(transcriptResponse.messages);
              const membersIdsWithIndex = (attendeeResponse.members || []).reduce(
                (attendeeIdsWithIndex, { id }, index) => ({
                  ...attendeeIdsWithIndex,
                  [id]: index,
                }),
                {}
              );
      
              setTranscriptMessages(formattedMessages);
              setAttendeesIdsWithIndex(membersIdsWithIndex);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
      
          fetchData();
        }
    }, [conversationId]);

    if (callScore && transcriptMessages) {
        return (
            <div className={"call-score-content"}>
                {/* <div className={"menu-items"}>
                    {
                        MENU_ITEMS.map(({key, name}) => <div key={key} className={`${selectedMenu === key ? "active-menu-tab" : ""}`} onClick={() => handleMenuClick(key)}>
                            <p>{name}</p>
                            <div className={"highlight"}></div>
                        </div>)
                    }
                </div> */}
                {
                    selectedMenu === MEETING_DETAILS_MENU.CALLSCORE
                    ? <>
                        <p className={"call-score-summary"}>{callScore?.summary}</p>
                        <CallScore callScore={callScore?.score} factors={callScore?.criteria} showColoredBackground={true} />
                        <CallScoreFactors factors={callScore?.criteria}/>
                    </>
                    : <Transcription messages={transcriptMessages} attendeesIdsWithIndex={attendeesIdsWithIndex} showAutoScroll={false} />
                }
            </div>
        )
    }

    return null;
};

const ViewCallScoreContainer = () => {
    const navigate = useNavigate();

    const navigateToCallScore = () => {
        navigate('/');
    }

    return  <div className={"call-score-details"} style={{ margin: '32px' }} >
        <div className={"call-score-header"}>
            <div className={"call-score-title"}>{`Call Score`}</div>
            <button className={"back-to-home"} 
                onClick={navigateToCallScore}
            >
            <p>Back to Home</p>
            </button>
        </div>
        <ViewCallScore />
    </div>
}

export default ViewCallScoreContainer;
